import { render, staticRenderFns } from "./goods-detail.vue?vue&type=template&id=29b286e0&"
import script from "./goods-detail.vue?vue&type=script&lang=js&"
export * from "./goods-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports